__turbopack_context__.v({
  "aspectBox": "CardStory-module-scss-module__rw1BLW__aspectBox",
  "image": "CardStory-module-scss-module__rw1BLW__image",
  "link": "CardStory-module-scss-module__rw1BLW__link",
  "listItem": "CardStory-module-scss-module__rw1BLW__listItem",
  "storyHeadline": "CardStory-module-scss-module__rw1BLW__storyHeadline",
  "storyHeadlineWrapper": "CardStory-module-scss-module__rw1BLW__storyHeadlineWrapper",
  "storySubHeadline": "CardStory-module-scss-module__rw1BLW__storySubHeadline",
  "textBlock": "CardStory-module-scss-module__rw1BLW__textBlock",
});
